var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrapper",staticClass:"company-logo",class:{small: _vm.small, 'compat-object-fit': !_vm.supportsObjectFit},style:(_vm.transformObject)},[(_vm.logo)?_c('img',{ref:"img",attrs:{"src":_vm.src,"alt":_vm.cname},on:{"load":_vm.refreshTransformDistance}}):_c('consents-main-logo',{staticClass:"consents-logo"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }